import sortBy from 'lodash/sortBy'

/**
 * This function gets the string and then return symbols after the last gap(' ')
 * @param {string} str require
 */
function getLastSymbol(str) {
    const arr = str.match(/(\s)(?!.*\1)[\w]*[\w]/gm)
    return arr ? arr[0].replace(/\s+/g, '') : str
}

/**
 * This function sort array by last symbol type in name (number or string)
 * @param {object} obj require
 * @param {string} getActiveLocale require ex: 'en' 'se'
 * @param {boolean} number by default true
 */

function sortByType(obj, getActiveLocale, number = true) {
    return obj.filter(o => {
        if(number) {
            return !isNaN(Number(getLastSymbol(getMetaFieldName(o, getActiveLocale))));
        } else {
            return isNaN(Number(getLastSymbol(getMetaFieldName(o, getActiveLocale))));
        }
    })
}

/**
 * This function returns meta name field by current locale. In case of absence needed field returns one of existing.
 * @param {object} obj require
 * @param {string} locale require ex: 'en' 'se'
 */

function getMetaFieldName(obj, locale) {
    const existMetaName = obj.meta['name_en'] || obj.meta['name_fi'] || obj.meta['name_se'];
    return obj.meta[`name_${locale}`] ?? existMetaName;
}

/**
 * sortedItems it's sorted items by the last symbol in alphabetical order
 * and if last symbol is number, move it to the end of the list
 * @param {object} obj is require
 * @param {string} getActiveLocale require ex: 'en' 'se'
 */

function sortedItems(obj, getActiveLocale) {
    const numberLastSymbolItems = sortByType(obj, getActiveLocale, false)
        .sort((a, b) => getMetaFieldName(a, getActiveLocale).localeCompare(getMetaFieldName(b, getActiveLocale)));
    const stringLastSymbolItems = sortBy(sortByType(obj, getActiveLocale), o => Number(getLastSymbol(getMetaFieldName(o, getActiveLocale))))

    return [...numberLastSymbolItems, ...stringLastSymbolItems]
}

export {
    sortedItems
};

//    const numberLastSymbolItems = sortByType(obj, getActiveLocale, false)
//      .sort((a, b) => getMetaFieldName(a, getActiveLocale).localeCompare(getMetaFieldName(b, getActiveLocale)));

// const stringLastSymbolItems = sortByType(obj, getActiveLocale)
//     .sort((a, b) => Number(getLastSymbol(getMetaFieldName(a, getActiveLocale))) > Number(getLastSymbol(getMetaFieldName(b, getActiveLocale)) ? 1 : -1))
